module.exports = __webpack_public_path__ + "media/assets/images/events/customer_engage-6b79167933465eab3cefdea4a4766582.png";